module.exports = __webpack_public_path__ + "assets/a839f2b6713cd9b4893c955421584398.jpg";